import React from "react";
// import FormProgress from '../UnitAdmin/FormProgress';
import FormProgress from "../AuditAdmin/FormProgress";
import FullscopeAccordion from "./FullscopeAccordion";

const FullScope = () => {
  return (
    <>
      <div className="addendum-main-container">
        <FormProgress />
        <div className="addendum-heading">Mars QMS - QMS Full Scope</div>
        <FullscopeAccordion />
      </div>
    </>
  );
};

export default FullScope;
